import type { SegmentsOptions } from '@openx/types/targeting/customVariables.ts';
import type { UseFetchSegmentsV2 } from '@openx/types/targeting/targetingHookTypes.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';
import { mapSegmentsOptions } from './mapSegmentsOptions.ts';

/**
 * Contextual Segments V2 (Advanced Targeting) loads the whole provider taxonomy in a single request.
 * It intentionally uses `optionsByPath`, because `searchOptionsByPath` caps `limit` at 500 on the API side.
 */
export const useFetchSegmentsV2: UseFetchSegmentsV2 = ({ account_id, provider_id, limit = 9000, offset = 0 }) => {
  const { data, loading } = useOptionsByPathQuery({
    skip: !account_id,
    variables: {
      filter: {
        account_id,
        limit,
        offset,
        ...(provider_id ? { provider_id } : {}),
      },
      path: 'deal.package.targeting.contextual.segments',
    },
  });

  const mappedSegments: SegmentsOptions = useMemo(() => mapSegmentsOptions(data?.optionsByPath ?? []), [data]);

  return { loading, segments: mappedSegments };
};
